/** Дочірні записи, створені на місці за цей сеанс: батьківський запис → ідентифікатори (найновіший першим). */
const created = new Map<string, string[]>();

/** Щойно створені дочірні записи батька (порядок для childOrder; переживає перемикання вкладок до перезавантаження сторінки). */
export function freshChildrenOf(parentId: string): string[] {
  return created.get(parentId) ?? [];
}

/** Запам'ятати новий дочірній запис першим; повертає оновлений перелік. */
export function addFreshChild(parentId: string, childId: string): string[] {
  const next = [childId, ...freshChildrenOf(parentId).filter((id) => id !== childId)];
  created.set(parentId, next);
  return next;
}
